class Accordion extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const titleElement = this.querySelectorAll(".collection__accordion-item-title");
        titleElement.forEach((element) => {
            element.addEventListener("click", this.toggleAccordion.bind(this));
        })

        const showMoreElement = this.querySelector(".collection__accordion-show-more .button");
        showMoreElement?.addEventListener("click", this.toggleMoreItems.bind(this));
    }

    toggleAccordion(event: Event) {
        const target = event.currentTarget as HTMLElement;
        const accordionElement = target?.parentElement;
        accordionElement?.classList.toggle("open");
    }

    toggleMoreItems(event: Event) {
        const hiddenItemElements = this.querySelectorAll('.collection__accordion-item-more');
        hiddenItemElements.forEach((element) => {
            element.classList.toggle('hidden');
        })

        const target = event.currentTarget as HTMLElement;
        target.classList.toggle("active");
    }
}


customElements.define("section-accordion", Accordion);